import { default as actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('skillbar');

export const setSkillBarName = actionCreator<string>('SET_SKILL_BAR_NAME');
